// src/pages/inspector/InspectorLogin.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInspectorAuth } from '../../context/InspectorAuthContext';
import { authAPI } from '../../services/api';
import styles from './InspectorLogin.module.css';

export default function InspectorLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useInspectorAuth();
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.login(email, password);
      const { user, token } = res.data;
      if (user.role !== 'inspector') {
        setError('Access denied. Inspector accounts only.');
        setLoading(false);
        return;
      }
      login(user, token);
      navigate('/inspector/dashboard');
    } catch (err) {
      // Stay on this page, just show the error
      setError(
        err.response?.data?.error || 'Invalid email or password'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      {/* Animated background grid */}
      <div className={styles.grid} />

      <div className={styles.card}>
        <div className={styles.badge}>INSPECTOR PORTAL</div>
        <h1 className={styles.title}>
          <span className={styles.accent}>Car</span>Inspector
        </h1>
        <p className={styles.subtitle}>AucwiniCars Inspection Network</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="inspector@aucwinicars.com"
              required
            />
          </div>
          <div className={styles.field}>
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <button type="submit" className={styles.btn} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In →'}
          </button>
        </form>

        <div className={styles.footer}>
          <a href="/">← Back to main site</a>
        </div>
      </div>
    </div>
  );
}